
import React from 'react';
import {connect } from 'react-redux';
import {Link} from "react-router-dom";

const Footer = (props) => {

    const show4Home = {
        display: (props.page === 'home') ? '' : 'none'
    };
    const hideNotAboutOrHomeContent = {
        display : (props.page === 'about' || props.page === 'home') ? '' : 'none'
    }
    const hideFrench = {
        display : (props.language === 'English') ? "none" : "block"
    }
    const hideEnglish = {
        display : (props.language === 'English') ? "block" : "none"
    }
    return ( 
        <footer id="footer">
        <div className="contact-bottom">
            <div className="contact">
                <div className="get_in_touch">
                    <div className="contact_line"></div>
                    <div className="text bluecolored" style={hideFrench}>Get in touch</div>
                    <div className="text bluecolored" style={hideEnglish}>Nous contacter</div>
                </div>
                <div className="phone">+1 450 672-0401</div>
                <div className="email">contact@vmn.net</div>
                <div className="address">
                    201 - 4 Place-du-Commerce
                    <br/>Brossard, Quebec
                    <br/>J4W 3B3
                    <br/>Canada    
                </div>
            </div>
        </div>
        <div className="useful_links" style={hideFrench}>
            <div className="title bluecolored">Useful links</div>
            <div className="links">
                <div className="link" style={show4Home}><a href="#our_products" className="smooth-goto">Products</a></div>
                <div className="link" style={hideNotAboutOrHomeContent}><a href="#our_clients" className="smooth-goto">Clients</a></div>
                <div className="link"><Link to="/about">About</Link></div>
                <div className="link"><Link to="/pressrelease/25thanniversary">Press release</Link></div>
            </div>
        </div>
        <div className="useful_links" style={hideEnglish}>
            <div className="title bluecolored">Liens utiles</div>
            <div className="links">
                <div className="link" style={show4Home}><a href="#our_products" className="smooth-goto">Produits</a></div>
                <div className="link" style={hideNotAboutOrHomeContent}><a href="#our_clients" className="smooth-goto">Clients</a></div>
                <div className="link"><Link to="/about">À propos</Link></div>
                <div className="link"><Link to="/pressrelease/25thanniversary">Communiqué de presse</Link></div>
            </div>
        </div>
        <div className="keep_in_touch">
            <div className="title bluecolored" style={hideFrench}>Keep in Touch</div>
            <div className="title bluecolored" style={hideEnglish}>Nous contacter</div>
            <div className="get_in_social">
                <div className="social_icons">
                    <div>
                        <a href="https://www.facebook.com/VisicomMedia/">
                        <svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.67 3.5H6.33A2.83 2.83 0 0 0 3.5 6.33v15.34a2.83 2.83 0 0 0 2.83 2.83h7.566l.012-7.504h-1.95a.46.46 0 0 1-.46-.458l-.008-2.42a.46.46 0 0 1 .46-.461h1.946v-2.338c0-2.712 1.656-4.189 4.076-4.189h1.985a.46.46 0 0 1 .46.46v2.04a.46.46 0 0 1-.46.46H18.74c-1.316 0-1.57.626-1.57 1.543v2.024h2.89c.276 0 .49.24.458.514l-.287 2.419a.46.46 0 0 1-.457.406h-2.592L17.17 24.5h4.501a2.83 2.83 0 0 0 2.83-2.83V6.33a2.83 2.83 0 0 0-2.83-2.83z" fill="#edeff3" opacity=".6"></path>
                    </svg>
                        </a>
                    </div>
                    <div>
                        <a href="https://twitter.com/visicommedia?lang=en">
                        <svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.166 7.6c-.467.207-.95.37-1.448.488.548-.52.96-1.171 1.192-1.898a.237.237 0 0 0-.346-.275 8.355 8.355 0 0 1-2.214.914.587.587 0 0 1-.526-.13 4.527 4.527 0 0 0-2.996-1.131c-.478 0-.96.074-1.434.221a4.386 4.386 0 0 0-2.956 3.16 4.832 4.832 0 0 0-.107 1.668.168.168 0 0 1-.182.183 11.872 11.872 0 0 1-8.16-4.36.237.237 0 0 0-.388.03 4.524 4.524 0 0 0-.613 2.277c0 1.227.493 2.384 1.35 3.227a4.06 4.06 0 0 1-1.033-.4.237.237 0 0 0-.351.204 4.533 4.533 0 0 0 2.644 4.177H6.5c-.253 0-.51-.024-.763-.072a.237.237 0 0 0-.27.305 4.538 4.538 0 0 0 3.585 3.086c-1.386.93-3 1.421-4.68 1.421H3.85a.347.347 0 0 0-.339.261.359.359 0 0 0 .172.396 12.427 12.427 0 0 0 6.244 1.684c1.919 0 3.714-.38 5.336-1.132a11.784 11.784 0 0 0 3.904-2.926 12.828 12.828 0 0 0 2.39-4.004c.532-1.42.813-2.935.813-4.382v-.069a.77.77 0 0 1 .289-.6 8.947 8.947 0 0 0 1.8-1.975c.132-.197-.076-.444-.293-.348z" fill="#edeff3" opacity=".6"></path>
                    </svg>
                        </a>
                    </div>
                    <div>
                        <a href="https://www.linkedin.com/company/visicom-media">
                        <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M19.75 0.5H2.25C1.78603 0.500531 1.34122 0.685076 1.01315 1.01315C0.685076 1.34122 0.500531 1.78603 0.5 2.25V19.75C0.500531 20.214 0.685076 20.6588 1.01315 20.9869C1.34122 21.3149 1.78603 21.4995 2.25 21.5H19.75C20.214 21.4995 20.6588 21.3149 20.9869 20.9869C21.3149 20.6588 21.4995 20.214 21.5 19.75V2.25C21.4995 1.78603 21.3149 1.34122 20.9869 1.01315C20.6588 0.685076 20.214 0.500531 19.75 0.5ZM7.5 16.2501C7.5 16.4822 7.40781 16.7047 7.24372 16.8688C7.07962 17.0329 6.85706 17.1251 6.625 17.1251C6.39294 17.1251 6.17038 17.0329 6.00628 16.8688C5.84219 16.7047 5.75 16.4822 5.75 16.2501V9.2501C5.75 9.01804 5.84219 8.79548 6.00628 8.63138C6.17038 8.46729 6.39294 8.3751 6.625 8.3751C6.85706 8.3751 7.07962 8.46729 7.24372 8.63138C7.40781 8.79548 7.5 9.01804 7.5 9.2501V16.2501ZM6.625 7.0626C6.36541 7.0626 6.11165 6.98563 5.89581 6.84141C5.67998 6.69719 5.51175 6.4922 5.41241 6.25237C5.31307 6.01255 5.28708 5.74865 5.33772 5.49405C5.38836 5.23945 5.51337 5.00558 5.69692 4.82202C5.88048 4.63847 6.11434 4.51346 6.36894 4.46282C6.62354 4.41218 6.88744 4.43817 7.12727 4.53751C7.3671 4.63685 7.57208 4.80508 7.7163 5.02092C7.86052 5.23676 7.9375 5.49051 7.9375 5.7501C7.9375 6.0982 7.79922 6.43204 7.55308 6.67818C7.30694 6.92432 6.9731 7.0626 6.625 7.0626ZM17.125 16.2501C17.125 16.4822 17.0328 16.7047 16.8687 16.8688C16.7046 17.0329 16.4821 17.1251 16.25 17.1251C16.0179 17.1251 15.7954 17.0329 15.6313 16.8688C15.4672 16.7047 15.375 16.4822 15.375 16.2501V12.3126C15.375 11.7324 15.1445 11.176 14.7343 10.7658C14.3241 10.3556 13.7677 10.1251 13.1875 10.1251C12.6073 10.1251 12.0509 10.3556 11.6407 10.7658C11.2305 11.176 11 11.7324 11 12.3126V16.2501C11 16.4822 10.9078 16.7047 10.7437 16.8688C10.5796 17.0329 10.3571 17.1251 10.125 17.1251C9.89294 17.1251 9.67038 17.0329 9.50628 16.8688C9.34219 16.7047 9.25 16.4822 9.25 16.2501V9.2501C9.24993 9.03501 9.32911 8.82744 9.47241 8.66704C9.61571 8.50664 9.81309 8.40466 10.0268 8.3806C10.2406 8.35653 10.4557 8.41206 10.6311 8.53657C10.8064 8.66108 10.9298 8.84585 10.9776 9.05557C11.5693 8.65344 12.2595 8.42023 12.9739 8.38102C13.6883 8.34181 14.3998 8.49808 15.032 8.83304C15.6642 9.16799 16.1931 9.66895 16.5619 10.282C16.9307 10.8951 17.1254 11.5971 17.125 12.3126V16.2501Z" fill="#edeff3" opacity=".6"></path>
					</svg>
                        </a>
                    </div>
                </div>
            </div>
            <div className="copyright" style={hideFrench}>&copy; 2022 Visicom Media Inc. All Rights Reserved. <Link to="/privacy">Privacy Policy</Link></div>
            <div className="copyright" style={hideEnglish}>&copy; 2022 Visicom Media Inc. Tous droits réservés. <Link to="/privacy">Politique de confidentialité</Link></div>
        </div>
    </footer>
     );
}
 
const mapStateToProps = state => {
    return {
        language : state.language
    };
};

const mapDispatchToProps = dispatch => {
    return{
        onChangeLanguage: (language) => dispatch({ type: language })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);